import React from 'react';

import { Modal } from 'src/components/common';
import { ApproveOrDeclineVerificationRequestByEmployeeModalContent } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import type { DeclineVerificationRequestByEmployeeModalArgs } from './types';

export const DeclineVerificationRequestByEmployeeModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<DeclineVerificationRequestByEmployeeModalArgs>(
      ModalId.DeclineVerificationRequestByEmployee,
    );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (isOpen && !args?.inboxItemId) {
    throw new Error('Missing inboxItemId in modal args');
  }

  return (
    <Modal
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={550}
    >
      <ApproveOrDeclineVerificationRequestByEmployeeModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        inboxItemId={args?.inboxItemId || ''}
        action="decline"
      />
    </Modal>
  );
};
